import { ensureAssistantMetadataInstruction } from '@/components/org-chat/composer-text-utils';

type AutoSendMessage = {
  startupMode?: 'auto-send' | 'draft';
  additionalInstructions?: string;
};

export function normalizeAutoSendMessage<T extends AutoSendMessage>(
  data: T
): T {
  if (data.startupMode !== 'auto-send' || !data.additionalInstructions) {
    return data;
  }

  const additionalInstructions = ensureAssistantMetadataInstruction(
    data.additionalInstructions
  );
  if (additionalInstructions === data.additionalInstructions) return data;

  return { ...data, additionalInstructions };
}
